"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = require("../../shared/utils/currency");
function generateTableRowsFromScheduledPayments(bbva) {
    const tableRows = [];
    bbva.installmentPlan.scheduledPayments.forEach((payment) => {
        tableRows.push([
            payment.number,
            (0, currency_1.parseToMexicanPeso)(payment.remaining.principal.amount),
            (0, currency_1.parseToMexicanPeso)(payment.remaining.additionalData[0].amount),
            (0, currency_1.parseToMexicanPeso)(payment.remaining.additionalData[1].amount),
            (0, currency_1.parseToMexicanPeso)(payment.principal.amount),
            (0, currency_1.parseToMexicanPeso)(payment.interest.amount),
            (0, currency_1.parseToMexicanPeso)(payment.tax.amount),
            (0, currency_1.parseToMexicanPeso)(payment.total.amount),
        ]);
    });
    return tableRows;
}
exports.default = generateTableRowsFromScheduledPayments;
